import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tenants: [],
  selectedTenant: null,
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenants(state, action) {
      state.tenants = action.payload;
    },
    setSelectedTenant(state, action) {
      state.selectedTenant = action.payload;
    },
  },
});

export const { setTenants, setSelectedTenant } = tenantSlice.actions;
export default tenantSlice.reducer;
